import { getSettingChatHolidays } from "@faire/help-center-utils/settings/getSettingChatHolidays";
import { getSettingPhoneHolidays } from "@faire/help-center-utils/settings/getSettingPhoneHolidays";

type ServiceType = "chat" | "phone";

const isSupportServiceInHolidayMode = (service: ServiceType) => {
  // holiday dates in timestamp format, such as 1700697600000
  const holidays =
    service === "phone" ? getSettingPhoneHolidays() : getSettingChatHolidays();
  const currentDate = new Date().toJSON().slice(0, 10);
  const currentDateTimestamp = new Date(currentDate).getTime();
  const isHoliday = holidays.includes(currentDateTimestamp);
  return isHoliday;
};

export const isChatInHolidayMode = () => {
  return isSupportServiceInHolidayMode("chat");
};

export const isPhoneInHolidayMode = () => {
  return isSupportServiceInHolidayMode("phone");
};
